import { Inject, Injectable, InjectionToken, PLATFORM_ID } from '@angular/core';
import { createEffect, ofType, Actions } from '@ngrx/effects';
import { of } from 'rxjs';
import * as NewslettersActions from '../actions/newsletters.action';
import { switchMap, map, catchError, tap } from 'rxjs/operators';
import { NewslettersService } from '../../services';
import { isPlatformBrowser } from '@angular/common';

@Injectable()
export class NewslettersEffects {
  private STORAGE_KEY = 'NEWSLETTER_POPUP';

  constructor(
    private actions$: Actions,
    private service: NewslettersService,
    @Inject(PLATFORM_ID) private platformId: InjectionToken<any>
  ) {}

  LoadPosts$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(NewslettersActions.Subscribe),
      switchMap(({ email }) =>
        this.service.Subscribe(email).pipe(
          map(result => NewslettersActions.SubscribeSuccess({ result })),
          catchError(error => of(NewslettersActions.SubscribeFail({ error })))
        )
      )
    );
  });

  InitNewsletterPopupSettings$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(NewslettersActions.InitNewsletterPopup),
      map(() => {
        const storedSettings = this.getStoredNewsletterData();

        // als deze bestaat toon window nooit meer
        if (storedSettings) {
          return NewslettersActions.HideNewsletterPopup();
        }
        return NewslettersActions.clearNewsletterPopup();
      }),
      catchError(error => of(NewslettersActions.InitNewsletterPopupSettingsFail({ error })))
    );
  });

  closeNewsletterPopup$ = createEffect(
    () => {
      return this.actions$.pipe(
        ofType(NewslettersActions.HideNewsletterPopup),
        tap(() => {
          this.setNewsletterData(false);
        })
      );
    },
    { dispatch: false }
  );

  showNewsletterPopup$ = createEffect(
    () => {
      return this.actions$.pipe(
        ofType(NewslettersActions.ShowNewsletterPopup),
        tap(() => {
          // localStorage.setItem(this.STORAGE_KEY, JSON.stringify(preferences));
          this.setNewsletterData(true);
        })
      );
    },
    { dispatch: false }
  );

  ClearNewsletterPopupSettings$ = createEffect(
    () => {
      return this.actions$.pipe(
        ofType(NewslettersActions.clearNewsletterPopup),
        tap(() => {
          // localStorage.removeItem(this.STORAGE_KEY);
          this.removeNewsletterData();
        })
      );
    },
    { dispatch: false }
  );

  private getStoredNewsletterData() {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    return localStorage.getItem(this.STORAGE_KEY);
  }

  private setNewsletterData(data: any) {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    localStorage.setItem(this.STORAGE_KEY, JSON.stringify(data));
  }

  private removeNewsletterData() {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    localStorage.removeItem(this.STORAGE_KEY);
  }
}
